/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import can from 'can';
import template from './pill.stache';
import dtm from 'scripts/services/dtm';
import appContext from 'scripts/app-context';

const PILL_KEY = 'pillHidden';

can.Component.extend({
    tag: 'pill',
    template: template,
    leakScope: false,
    viewModel: {
        define: {
            localPill: {
                type: 'object',
                value: {},
            },
            globalPill: {
                type: 'object',
                value: {},
            },
            show: {
                type: 'boolean',
                value: false,
            },
            data: {
                get() {
                    if (window.globalSettings.inWebView) {
                        this.attr('show', false);
                        return;
                    }

                    if (this.attr('localPill.active')) {
                        this.attr(
                            'show',
                            !localStorage.getItem(
                                `${PILL_KEY}${this.localPill.identifier}`,
                            ),
                        );

                        return this.localPill;
                    }

                    if (this.attr('globalPill.active')) {
                        this.attr(
                            'show',
                            !localStorage.getItem(
                                `${PILL_KEY}${this.globalPill.identifier}`,
                            ),
                        );

                        return this.globalPill;
                    }
                },
            },
        },
        hidePill() {
            this.attr('show', false);
            localStorage.setItem(
                `${PILL_KEY}${this.attr('data.identifier')}`,
                true,
            );
        },
        onCtaClick() {
            dtm.trackPillModuleLink(this.attr('data.title'));
            window.open(this.attr('data.url'));
        },
    },
    events: {
        init() {
            appContext.model.attr('pill-module-visible', false);
            this.viewModel.bind('show', (event, value) => {
                appContext.model.attr('pill-module-visible', value);
            });
        },
    },
});
